import { locationOptions } from '../../data/locationOptions';

type Option = { value: string; label: string };
type OptionGroup = { label: string; options: Option[] };

// Names Google's lookup returns that differ from the ones our dropdown and the
// backend timezone map use. Everything else comes back matching already.
const GEOCODED_STATE_ALIASES: Record<string, string> = {
  'district of columbia': 'Washington DC',
};

const allStateValues = (locationOptions as OptionGroup[]).flatMap((group) =>
  group.options.map((option) => option.value)
);

/**
 * Turn the state name the address lookup gives us into the one the rest of the
 * app uses.
 *
 * A state we do not recognise is passed through untouched, so the member can
 * correct it in the dropdown rather than losing what was found.
 */
export const normaliseGeocodedState = (state: string): string => {
  const trimmed = state.trim();
  if (!trimmed) return '';

  const known = allStateValues.find(
    (value) => value.toLowerCase() === trimmed.toLowerCase()
  );
  if (known) return known;

  return GEOCODED_STATE_ALIASES[trimmed.toLowerCase()] ?? trimmed;
};
